


















import { Component, Vue } from 'vue-property-decorator';
import ReportContainer from '@/modules/neodash/components/report-container/report-container.vue';
import FilterContainer from '@/modules/neodash/components/filter-container/filter-container.vue';
import MarketBreakDownFilter from '@/modules/neodash/pages/marketBreakDown/market-break-down.filter.vue';
import { FormFilterFields } from '@/modules/neodash/model/types/interfaces/FormFilterFields';
import { Filter } from '@/modules/neodash/pages/marketBreakDown/Filter';
import PageLoader from '@/components/page-loader/page-loader.vue';
import ReportVueContainer from '@/modules/neodash/components/report-vue-container/report-vue-container.vue';
import MarketBreakDownRegistrationReport from '@/modules/neodash/pages/marketBreakDown/market-break-down-registration.report.vue';
import { MarketBreakdownReportTypeEnum } from '@/enums/market-breakdown-report-type.enum';
import MarketBreakDownSalesReport from '@/modules/neodash/pages/marketBreakDown/market-break-down-sales.report.vue';
import * as moment from 'moment';
import { ServiceHelper } from '@/utils/service.helper';
import { i18nMixin } from '@/modules/neodash/mixins';
import { CONFIG } from '@/config';
import {httpService, traceLogAccess} from '@/services';
import { AxiosResponse } from 'axios';
import _ from 'lodash';
import {ContextEnum} from '@/enums/context.enum';

@Component({
  name: 'MarketBreakdown',
  components: {
    MarketBreakDownSalesReport,
    MarketBreakDownFilter,
    ReportContainer,
    ReportVueContainer,
    FilterContainer,
    PageLoader,
    MarketBreakDownRegistrationReport
  }
})
export default class MarketBreakdown extends Vue {
  public translate = i18nMixin.methods.i18n;
  public model = {
    labels: [],
    value: {} as Filter
  } as FormFilterFields<Filter>;
  public state: any = {
    dataSource: [],
    requestData: {},
    client: ''
  };

  public get showRegistrationAnalysisReport() {
    const myAnalysisType = this.state.requestData.AnalysisType != null ? this.state.requestData.AnalysisType.value : 0;
    return myAnalysisType === MarketBreakdownReportTypeEnum.registration;
  }

  public get showSalesAnalysisReport() {
    const myAnalysisType = this.state.requestData.AnalysisType != null ? this.state.requestData.AnalysisType.value : 0;
    return myAnalysisType === MarketBreakdownReportTypeEnum.sales;
  }

  public getTypeSales(type) {
    switch (type) {
      case 1:
        return this.translate('Common.Retail');
      case 2:
        return this.translate('Common.DirectSales');
      case 3:
        return 'Total';
      default:
        return '';
    }
  }

  public showReport() {
    const { clientLocality, saleType, typeLocalityLevel, period, localeType, analysisType } = this.model.value;
    if (!(!!saleType || !!clientLocality)) {
      return;
    }
    const setObjectValue = nameValue => (nameValue != null ? { value: nameValue.value, text: this.translate(nameValue.name) } : {});
    let initialDate = new Date(),
      endDate = new Date();
    if (!!period) {
      initialDate = new Date(period.value.dtYearInit, period.value.dtMonthInit - 1);
      endDate = new Date(period.value.dtYearFinal, period.value.dtMonthFinal - 1);
    }

    this.state.requestData = {
      LevelLocality: setObjectValue(typeLocalityLevel),
      TypeLocality: setObjectValue(localeType),
      SalesType: setObjectValue(saleType),
      EndYear: setObjectValue({ value: endDate.getFullYear() }),
      EndMonth: setObjectValue({ value: endDate.getMonth() + 1 }),
      StartYear: setObjectValue({ value: initialDate.getFullYear() }),
      StartMonth: setObjectValue({ value: initialDate.getMonth() + 1 }),
      GeoCodes: [],
      Name:
        setObjectValue(analysisType).value === 2
          ? this.translate('Common.Registration')
          : this.translate('Common.Sales'),
      AnalysisType: setObjectValue(analysisType),
      ClientLocality: setObjectValue(clientLocality)
    };

    if (this.state.requestData.LevelLocality.value == 2) {
      this.state.requestData.GeoCodes.push(setObjectValue(clientLocality).value);
    }

    // This report show report by Sector Census. Today all values are Retail.
    if (this.state.requestData.LevelLocality.value != -1) {
      this.state.requestData.SalesType = { name: 'Varejo', value: 1 };
    }

    const params = {
      AnalysisType: this.state.requestData.AnalysisType.value,
      LevelLocality: this.state.requestData.LevelLocality.value,
      TypeLocality: this.state.requestData.TypeLocality.value,
      SalesType: this.state.requestData.SalesType.value,
      StartYear: this.state.requestData.StartYear.value,
      StartMonth: this.state.requestData.StartMonth.value,
      EndYear: this.state.requestData.EndYear.value,
      EndMonth: this.state.requestData.EndMonth.value,
      GeoCodes: this.state.requestData.GeoCodes,
      Name: this.state.requestData.Name
    };

    traceLogAccess.logAction(ContextEnum.Report, `Market Break Down ${this.state.requestData.AnalysisType.value} - Filtro`, JSON.stringify(params));
    httpService.http
      .post(`${CONFIG.URL.NEODASH_API}/api/gigdash/marketBreakDown/getAnalysisPMA`, params)
      .then((res: AxiosResponse) => {
        this.state.dataSource = _.cloneDeep(
          _(res.data.analysis)
            .map(f => f)
            .value()
        );
        this.state.client = res.data.clientName;
      });
  }

  public exportToExcel() {
    if (this.state.requestData.LevelLocality == 2) {
      this.state.requestData.geoCodes.push(this.state.requestData.LevelLocality);
    }

    const params = {
      typeSales: this.getTypeSales(parseInt(this.state.requestData.SalesType.value)),
      levelLocality: this.state.requestData.LevelLocality.value,
      typeLocality: this.state.requestData.TypeLocality.value,
      saleType: this.state.requestData.LevelLocality.value == -1 ? this.state.requestData.SalesType.value : 3,
      dtYearInit: this.state.requestData.StartYear.value,
      dtMonthInit: this.state.requestData.StartMonth.value,
      dtYearFinal: this.state.requestData.EndYear.value,
      dtMonthFinal: this.state.requestData.EndMonth.value,
      geoCodes: this.state.requestData.GeoCodes,
      analysisType: this.state.requestData.AnalysisType.value
    };

    const fileName = `Market Break Down - ${this.state.requestData.Name} - ${moment().format('YYYYMMDD_HHmmss')}.xlsx`;
    traceLogAccess.logAction(ContextEnum.Report, `Market Break Down ${this.state.requestData.AnalysisType.value} - Download`, JSON.stringify(params));

    ServiceHelper.generateFile(`${CONFIG.URL.NEODASH_API}/api/neodash/getExcel/marketBreakDown`, fileName, {
      method: 'post',
      parameters: params
    });
  }
}
